<template><div><h1 id="exportformate" tabindex="-1"><a class="header-anchor" href="#exportformate"><span>Exportformate</span></a></h1>
<p>Exportformate — Definition der Felder und Formate für den Datenexport</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit den Exportformaten können Datenexporte aus funtrade definiert werden. Die Definition beinhaltet die Festlegung des Typs, z.B. Text oder XML, der Seperatoren und weiterer Eigenschaften. Die Verknüpfung mit den einzelnen Exportfeldern ist unter <RouteLink to="/referenz/refs/ft.refdata.exportfeld.html" title="Exportfelder">Exportfelder</RouteLink> beschrieben.</p>
<p>Pfad: <code v-pre>Datenaustausch → Tabellen → Exportformate → Exportformate</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Exportformat</dt>
<dd>Bezeichnung des Exportformates.</dd>
<dt>Beschreibung</dt>
<dd>Freier Beschreibungstext.</dd>
<dt>Verwendung</dt>
<dd>Einschränkung der Verwendung auf die Bereiche. Das Exportformat steht nur in den definierten Bereichen zur Auswahl (im Lookup). Folgende Möglichkeiten stehen zur Auswahl:
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Alles</td>
<td>Das Exportformat steht in allen Bereichen zur Verfügung.</td>
</tr>
<tr>
<td>Andere</td>
<td>Das Exportformat steht in speziellen Bereichen zur Verfügung, z.B. Guthaben-Avisierung, Korrespondenz, Verdankungen, etc.</td>
</tr>
<tr>
<td>Adress-Export</td>
<td>Das Exportformat steht im Bereich Adress-Export zur Verfügung.</td>
</tr>
<tr>
<td>Zusage-Beitragfakturierung</td>
<td>Das Exportformat steht im Bereich Zusagenfakturierung zur Verfügung.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Typ</dt>
<dd>Typ des Exports. Folgende Möglichkeiten stehen zur Auswahl:
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>CSV</td>
<td>Es wird ein File mit einem definierten Trennzeichen erstellt.</td>
</tr>
<tr>
<td>System</td>
<td>Spezieller Typ für die Verwendung vom system-internen erstellten Files.</td>
</tr>
<tr>
<td>Excel</td>
<td>Es wird ein Excel-File erstellt.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Zeichensatz</dt>
<dd>Auswahl zwischen dem Zeichensatz ISO-8859-1 oder UTF-8. Es wird empfohlen UTF-8 zu verwenden.</dd>
<dt>Spaltenüberschrift</dt>
<dd>Spaltenüberschrift im Export übernehmen (ja/nein)</dd>
<dt>Trennzeichen</dt>
<dd>Folgende Möglichkeiten stehen zur Auswahl:
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Komma</td>
<td>Es wird ein File mit dem Trennzeichen Komma (,) erstellt.</td>
</tr>
<tr>
<td>Semikolon</td>
<td>Es wird ein File mit dem Trennzeichen Semikolon (😉 erstellt.</td>
</tr>
<tr>
<td>Tabulator</td>
<td>Es wird ein File mit dem Trennzeichen Tabulator erstellt.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Texterkennungszeichen</dt>
<dd>Im Export können die Daten mit Texterkennungszeichen versehen werden. Folgende Möglichkeiten stehen zur Auswahl:| Auswahl | Beschreibung
|
| --- | --- |
| kein | Es wird ein File ohne Texterkennungszeichen erstellt. |
| Apostroph | Es wird ein File mit dem Texterkennungszeichen Apostroph (') erstellt. |
| Anführungszeichen | Es wird ein File mit dem Texterkennungszeichen Anführungszeichen (&quot;) erstellt. |</dd>
<dt>Referenzwerte</dt>
<dd>Platzhalter, die in den &quot;parametrisierbaren Exportfeldern&quot; (siehe <a class="link" href="ft.refdata.exportfeld.html" title="Exportfelder">Exportfelder</a> ) genutzt werden können. Das Feld &quot;Referenz&quot; ist eine frei Wählbare Bezeichnung. Im Feld &quot;Typ/Wert&quot; kann ein Typ (z.B. &quot;aktuelles Datum&quot; oder &quot;Text&quot;) ausgewählt und, wo möglich, mit einem Wert versehen werden.</dd>
</dl>
<h2 id="datenfelder-exportformat-positionen" tabindex="-1"><a class="header-anchor" href="#datenfelder-exportformat-positionen"><span>Datenfelder (Exportformat Positionen)</span></a></h2>
<dl>
<dt>Pos.</dt>
<dd>Definiert die Reihenfolge der einzelnen Spalten/Exportfelder.</dd>
<dt>Spaltenüberschrift</dt>
<dd>Freier Text für die Überschriften der exportierten Spalten.</dd>
<dt>Exportfeld</dt>
<dd>Bezeichnung des Exportfeldes resp. Felder für Erfassung der Werte bei parametrisierbaren Exportfeldern.</dd>
<dt>Länge</dt>
<dd>Eintrag der Anzahl Zeichen bei fester Länge. Muss zusammen mit Feld &quot;Richtung&quot; erfasst werden.</dd>
<dt>Richtung</dt>
<dd>&quot;L&quot; oder &quot;R&quot; definiert die Ausrichtung bei Feldern mit fester Länge.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="drucken" tabindex="-1"><a class="header-anchor" href="#drucken"><span>Drucken...</span></a></h3>
<p>Erstellt einen Ausdruck des Exportformates mit sämtlichen Exportfeldern.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.exportfeld.html" title="Exportfelder">Exportfelder</RouteLink></p>
</div></template>


